import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Close modal
    const modal = document.getElementById("auto_topup_modal") as HTMLDialogElement;
    modal?.close();

    // Show success toast
    window.toast?.("Auto top-up settings saved.", { type: "success" });

    // Clean up
    this.element.remove();
  }
}

